<template>
  <div id="LogCommunityServiceHours" class="wrap">

    <v-app-bar class="grey lighten-3 desktopHeader--remove hidden-md-and-up" fixed elevate-on-scroll>
       <v-layout class="justify-center"> <span class="title light-blue--text text--darken-3 text-center">Log Hours</span></v-layout>
    </v-app-bar>

    <div class="maxContainer" v-if="communityServiceHoursDetail">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 px-0 ">
        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
        <v-layout column align-center class="hidden-sm-and-down">
          <v-layout class="justify-center"> <span class="title light-blue--text text--darken-3 text-center">Log Hours</span></v-layout>
          <span>{{communityServiceHoursDetail.organization_name}}</span>
        </v-layout>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          hide-slider
          grow
          class=" pt-4"
          >
          <v-tab active-class="grey darken-3 white--text" style="marginLeft:0px;">
            Single Date
          </v-tab>

          <v-tab active-class="grey darken-3 white--text">
            Date Range
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- Single Date   -->
          <v-tab-item class="mt-5">
            <!-- Single  Date -->
            <v-flex xs12 >
              <v-menu :close-on-content-click="false"
                      v-model="menu2"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="computedSingleDateFormattedMomentjs"
                    label="Single Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    clearable
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker  v-model="date"  no-title @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Single Shadowing Hours -->
            <v-text-field v-model="hours"
                          label="Hours"
                          prepend-inner-icon="mdi-clock-outline"
                          outlined>
            </v-text-field>

            <!-- Log Single Date -->
            <v-layout row class="mt-2 mb-3 mx-1">
              <v-btn  color="green"
                      @click="logCommunityServiceHours()"
                      block
                      depressed
                      :disabled="checkSingleHours"
                      large>
                <span class="white--text"> Add Hours</span>
              </v-btn>
            </v-layout>
          </v-tab-item>

          <!-- Date Range  -->
          <v-tab-item class="mt-5">

              <!-- From Date -->
              <v-flex xs="12" >
                <v-menu
                    :close-on-content-click="false"
                    v-model="menu3"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="computedFromDateFormattedMomentjs"
                                  label="Start Date"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  clearable
                                  outlined
                                  v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker  v-model="from_date" no-title @input="menu3 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- To Date -->
              <v-flex xs="12" >
                <v-menu :close-on-content-click="false"
                        v-model="menu4"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field :value="computedToDateFormattedMomentjs"
                                  label="End Date"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  clearable
                                  outlined
                                  v-on="on"
                                ></v-text-field>
                  </template>
                  <v-date-picker  v-model="to_date" no-title @input="menu4 = false"></v-date-picker>
                </v-menu>
              </v-flex>


            <!-- Date Range Shadowing Hours -->
            <v-text-field v-model="date_range_hours"
                          label="Hours"
                          prepend-inner-icon="mdi-clock-outline"
                          outlined
                        >
            </v-text-field>

            <!-- Log Date Range Button -->
            <v-layout row class="mt-2 mb-3 mx-1">
              <v-btn
                color="green"
                @click="logCommunityServiceHours()"
                block
                depressed
                class="pl-0 ml-0"
                large
                :disabled="checkDateRangeHours"
                >

                <span class="white--text"> Add Hours</span>
              </v-btn>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>

    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2 fixed elevation-0 " color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>

  </div>
</template>

<script>
  import moment from 'moment'
export default {
  data () {
    return {
      tab: null,
      menu2: false,
      menu3: false,
      menu4: false,
      date: '',
      hours: '',
      to_date: '',
      from_date: '',
      date_range_hours: '',
    }
  },
  methods : {
    back() {
      this.$router.go(-1);
    },
     logCommunityServiceHours () {
       if(this.date_range_hours !== '' && this.date_range_hours  !== null ) {
          this.hours = this.date_range_hours
        }
        const loggedCommunityServiceHours = {
          date: this.date,
          hours : this.hours,
          to_date: this.to_date,
          from_date: this.from_date,
          date_range_hours: this.date_range_hours,
          communityServiceHours_id: this.id
        }

        this.$store.dispatch('setLogCommunityServiceHours', loggedCommunityServiceHours)

        this.date = '',
        this.hours = '',
        this.to_date = '',
        this.from_date = '',
        this.date_range_hours = '',
        this.$router.go(-1)
      }
  },
  computed : {
    id () {
      return this.$route.params.id
    },
    user () {
      return this.$store.getters.user
    },
    communityServiceHoursDetail() {
      return this.$store.getters.communityServiceHoursDetail(this.id);
    },
    checkSingleHours() {
        if(this.date === '' || this.hours === '' ) {
          return true
        } else {
          return false
        }
      },
      checkDateRangeHours() {
        if(this.from_date === '' || this.to_date === '' || this.date_range_hours === '') {
          return true
        } else {
          return false
        }
      },
      computedSingleDateFormattedMomentjs () {
        return this.date ? moment(this.date).format('MM/DD/YYYY') : ''
      },
      computedFromDateFormattedMomentjs () {
        return this.from_date ? moment(this.from_date).format('MM/DD/YYYY') : ''
      },
      computedToDateFormattedMomentjs () {
        return this.to_date ? moment(this.to_date).format('MM/DD/YYYY') : ''
      }
    },
     watch : {
      tab () {
        if(this.tab === 0 ) {
          this.from_date = '',
          this.to_date = '',
          this.date_range_hours = ''

        }
        if(this.tab === 1 ) {
          this.date = '',
          this.hours = ''

        }
      }
    }
}
</script>

<style scoped>
  #headerToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;
  }
 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
@media (min-width: 960px) {
  .desktopHeader {
    width: calc(100% - 256px);
    margin-left: 256px;
  }
}
@media (min-width: 960px) {
    .fixed {
        margin-bottom: 110px;
    }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
  padding-bottom: 40px;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.wrap {
  margin-top: 8vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/CommunityServiceHours/LogCommunityServiceHours.vue